import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { StatusEnum } from "../../../commons/enums/status-enum";
import { manageUserService } from "../../../commons";

interface IUserActiveState {
  userAssignAsAdminStatus: StatusEnum;
}

const initialState: IUserActiveState = {
  userAssignAsAdminStatus: StatusEnum.Idle,
};

export const userAssignAsAdmin = createAsyncThunk(
  "userAssignAsAdmin",
  async (userId: number, thunkAPI) => {
    try {
      const userAssignAsAdminResponse = await manageUserService.addUserToAdmin(
        userId
      );
      return userAssignAsAdminResponse;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

const userAssignAsAdminSlice = createSlice({
  name: "userAssignAsAdmin",
  initialState: initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(userAssignAsAdmin.pending, (state) => {
        state.userAssignAsAdminStatus = StatusEnum.Loading;
      })
      .addCase(userAssignAsAdmin.fulfilled, (state, action) => {
        state.userAssignAsAdminStatus = StatusEnum.Succeeded;
      })
      .addCase(userAssignAsAdmin.rejected, (state) => {
        state.userAssignAsAdminStatus = StatusEnum.Failed;
      });
  },
});

export default userAssignAsAdminSlice.reducer;
